import { render, staticRenderFns } from "./newContractList.vue?vue&type=template&id=941e924e&"
import script from "./newContractList.vue?vue&type=script&lang=js&"
export * from "./newContractList.vue?vue&type=script&lang=js&"
import style0 from "./newContractList.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports